module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productAnt"
  }, [_c('div', {
    staticClass: "visual_switch"
  }, [_c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 0
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 1
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "switch",
    class: {
      active: _vm.curProduct == 2
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(2)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container hidden-sm-down"
  }, [_c('div', {
    staticClass: "fullpage-container__bgImg"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "fullpage-wp"
  }, [_c('div', {
    staticClass: "page-1 page"
  }, [_c('div', {
    staticClass: "fullpage-container__title"
  }, [_vm._v("\n          威滅 速效殺蟻藥餌\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel"
  }, [_c('p', {
    staticClass: "fullpage-container__bottomPanel__text1"
  }, [_vm._v("\n            速效配方專為螞蟻而設，連環殺滅功能，助你輕鬆解決螞蟻困擾。\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "fullpage-container__bottomPanel__sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon,
      "srcset": _vm.locationIcon2x + ' 2x'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('img', {
    staticClass: "fullpage-container__bottomPanel__productImage",
    attrs: {
      "src": require("../assets/productAnt-section2.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-2 page"
  }, [_c('div', {
    staticClass: "suggestion-container"
  }, [_c('div', {
    staticClass: "suggestion"
  }, [_c('h2', [_vm._v("威滅其他產品")]), _vm._v(" "), _c('div', {
    staticClass: "product-btn"
  }, [_vm._m(1), _vm._v(" "), _c('router-link', {
    staticClass: "label-yellow",
    attrs: {
      "to": "/product/cockroach"
    }
  }, [_c('div', {
    staticClass: "aim"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/aimIcon.png")
    }
  })]), _vm._v(" "), _c('span', [_vm._v("速效曱甴藥餌")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": _vm.moveNextPage
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-3 page"
  }, [_c('contact'), _vm._v(" "), _c('div', {
    staticClass: "pageControl"
  }, [_c('button', {
    attrs: {
      "data-button": "next"
    },
    on: {
      "click": function($event) {
        _vm.scrollToProduct(0)
      }
    }
  }, [_c('span', {
    staticClass: "item item-half item-icon white"
  }, [_c('svg', {
    staticClass: "icon icon-arrow icon-rotate-up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 60 60",
      "xml:space": "preserve",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('path', {
    staticClass: "icon-path",
    attrs: {
      "d": "M14.2,52.5c-1.8,1.8-1.8,4.7,0,6.5c1.8,1.8,4.6,1.8,6.4,0l25.3-25.8c1.8-1.8,1.8-4.7,0-6.5L20.6,1c-1.8-1.8-4.6-1.8-6.4,0c-1.8,1.8-1.8,4.7,0,6.5L34.9,30L14.2,52.5z"
    }
  })])])])]), _vm._v(" "), _c('henkel-footer')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "section2"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "sellingLocation",
    on: {
      "click": function($event) {
        _vm.toggleOverlay(0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.locationIcon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("銷售地點")])]), _vm._v(" "), _c('div', {
    staticClass: "btnContainer"
  }, [_c('ul', _vm._l((_vm.overlayMenu), function(item, index) {
    return (index != 0) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.toggleOverlay(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "srcset": item.srcset + ' 2x'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "claimRef"
  }, [_vm._v("\n        *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "section-suggest"
  }, [_c('div', {
    staticClass: "suggestion-container"
  }, [_c('div', {
    staticClass: "suggestion"
  }, [_c('h2', [_vm._v("威滅其他產品")]), _vm._v(" "), _c('div', {
    staticClass: "product-btn"
  }, [_vm._m(5), _vm._v(" "), _c('router-link', {
    staticClass: "label-yellow",
    attrs: {
      "to": "/product/cockroach"
    }
  }, [_c('div', {
    staticClass: "aim"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/aimIcon.png")
    }
  })]), _vm._v(" "), _c('span', [_vm._v("速效曱甴藥餌")])])], 1)])])]), _vm._v(" "), _c('contact'), _vm._v(" "), _c('henkel-footer')], 1), _vm._v(" "), _c('div', {
    staticClass: "overlay",
    class: {
      active: _vm.openOverlay
    }
  }, [_c('div', {
    staticClass: "overlayBg",
    on: {
      "click": function($event) {
        _vm.toggleOverlay()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "closeBtn"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cross.png"),
      "srcset": _vm.crossBtn + ' 2x'
    },
    on: {
      "click": function($event) {
        _vm.toggleOverlay()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab tabChannel",
    class: {
      active: _vm.tabIndex === 0
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "tabTitle"
  }, [_vm._v("\n            威滅產品於下列商戶有售\n          ")]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "tab tabInfo",
    class: {
      active: _vm.tabIndex === 1
    }
  }, [_vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "tab tabMethod",
    class: {
      active: _vm.tabIndex === 2
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "shoplistCol row"
  }, _vm._l((_vm.overlayMethod), function(step) {
    return _c('div', {
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": step.src,
        "srcset": step.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(step.index))]), _vm._v(" "), _c('div', {
      staticClass: "shopName"
    }, [_vm._v(_vm._s(step.text))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "tab tabWorks",
    class: {
      active: _vm.tabIndex === 3
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "shoplistCol row"
  }, [_vm._m(12), _vm._v(" "), _vm._l((_vm.overlayWorks), function(work, index) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "shoplist"
    }, [_c('div', {
      staticClass: "imageContainer hidden-md-up"
    }, [_c('img', {
      staticClass: "shopLogo",
      attrs: {
        "src": work.src,
        "srcset": work.srcset + ' 2x'
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "methodNum"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "shopName"
    }, [_vm._v(_vm._s(work.text))])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("想了解更多詳細威滅藥餌的殺滅的效用，請瀏覽"), _c('router-link', {
    staticClass: "underline",
    attrs: {
      "to": '/preventiontips/insecticideguide'
    }
  }, [_vm._v("藥餌的殺滅效用")])], 1)])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "arrowContainer"
  }, [_c('div', {
    staticClass: "leftArrow",
    on: {
      "click": function($event) {
        _vm.previousOverlay()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/arrow.png"),
      "srcset": _vm.arrowBtn + ' 2x'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "rightArrow",
    on: {
      "click": function($event) {
        _vm.nextOverlayTab()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/arrow.png"),
      "srcset": _vm.arrowBtn + ' 2x'
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fullpage-container__bottomPanel__claimRef"
  }, [_c('div', [_vm._v("\n              *資料來源：Euromonitor Retail Value Comparison of Insecticide Baits Category in Hong Kong, Data 2014-2017, 2019-2021\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cockroach-suggest.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section1"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productAnt-section1-m.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "productImg"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productAnt-section2.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          威滅 速效殺蟻藥餌\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text1"
  }, [_vm._v("\n          速效配方專為螞蟻而設，連環殺滅功能，助你輕鬆解決螞蟻困擾。\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/cockroach-suggest.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productAnt-section2-icon1.png")
    }
  }), _vm._v("\n            銷售地點\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplistCol row"
  }, [_c('div', {
    staticClass: "col-md-4 offset-md-2"
  }, [_c('div', {
    staticClass: "shoplist welcomeShopLink"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/welcome.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("惠康超級市場")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.wellcome.com.hk/wd2shop/zh/html/search/search-result.html?hs_srch_word=combat",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/parkinShop.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shopInfo"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("百佳超級市場")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.parknshop.com/search?code=ALL&text=%E5%A8%81%E6%BB%85&searchField=%E5%A8%81%E6%BB%85",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/aeon.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("AEON")])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/yata.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("一田 YATA")])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/apita.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("UNY / APITA")])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "src": require("../assets/bamboos.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("百本旺角市集")])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/hktvMall.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HKTV Mall")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.hktvmall.com/hktv/zh/main/search?page=0&q=%3Arelevance%3Acategory%3AAA11824000001%3Azone%3Asupermarket%3Abrand%3ACombat%3Astreet%3Amain%3A",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/ztore.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("Ztore 士多")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.ztore.com/tc/search/combat",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/pandamart.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("PandaMart")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.foodpanda.hk/groceries#all-pandamarts",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/homeplus.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HOMEPLUS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.home-plus.hk/tc_hk/products?brand=17504",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/healthstore.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("HealthStore")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.healthstore.com.hk/collections/combat-威滅?utm_source=combat&utm_medium=referral&utm_campaign=brandsite",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/onlineShopBtn.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "shoplist row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/all_pharmacy.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "shopInfo col-sm-8"
  }, [_c('div', {
    staticClass: "shopName"
  }, [_vm._v("各大藥行藥房")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://docs.google.com/spreadsheets/d/1038226dN2l4fc_kwaJjAP6E5yiUBQNLo/edit?usp=sharing&ouid=109814576360705695639&rtpof=true&sd=true",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "shoplinkBtn",
    attrs: {
      "src": require("../assets/btn-pharmacylist.png")
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productAnt-section2-icon2.png")
    }
  }), _vm._v("\n            產品詳細資料\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shoplistCol row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "shoplist text-sm-center"
  }, [_c('img', {
    staticClass: "shopLogo logo2",
    attrs: {
      "src": require("../assets/productAnt-section2-overlay.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('div', {
    staticClass: "shopInfo"
  }, [_vm._v("\n                  藥餌數目:  6件裝 "), _c('br'), _vm._v("\n                  有效成份: Fipronil (快倍隆)"), _c('br'), _vm._v("\n                  生產地: 韓國 "), _c('br'), _c('br'), _vm._v("\n\n                  優點: "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "bulletList"
  }, [_c('li', [_vm._v("連環殺滅功能，將巢穴裡面螞蟻一網打盡。")]), _vm._v(" "), _c('li', [_vm._v("餌盒設計方便，簡單易用。")]), _vm._v(" "), _c('li', [_vm._v("無味無臭，對人體及環境不構成傷害。")]), _vm._v(" "), _c('li', [_vm._v("效力持續三個月有效。")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productAnt-section2-icon3.png")
    }
  }), _vm._v("\n            使用方法\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabName"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/productAnt-section2-icon4.png")
    }
  }), _vm._v("\n            連環殺滅功能\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 hidden-sm-down"
  }, [_c('div', {
    staticClass: "shoplist"
  }, [_c('img', {
    staticClass: "shopLogo",
    attrs: {
      "src": require("../assets/overlay-work.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d248f24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ProductAnt.vue
// module id = 239
// module chunks = 0